<template>
  <div>
    <Loader v-if="loading"></Loader>
    <div class="create_wrapper" v-else>
      <!-- Start Breadcrumb -->
      <Breadcrumb
        :items="items"
        :search="true"
        search_route="/importFiles/all"
        search_title="ملفات الاستيراد"
      />
      <!-- End Breadcrumb -->
      <div class="card-header">
        <h4 class="card-title mt-3">بيانات ملف الاستيراد</h4>
      </div>
      <ul class="all-state-count mt-0">
        <li>
          <div class="state-count">
            <span> رقم الملف :</span>
            <span>{{ data.file_number }}</span>
          </div>
        </li>
        <li>
          <div class="state-count">
            <span> رقم البوليصة :</span>
            <span>{{ data.polis_number }}</span>
          </div>
        </li>
        <li>
          <div class="state-count">
            <span> المبلغ :</span>
            <span> {{ data.amount }} </span>
          </div>
        </li>
        <li>
          <div class="state-count">
            <span> الشركة :</span>
            <span> {{ data.company.name }} </span>
          </div>
        </li>
        <li>
          <div class="state-count">
            <span> ملف البنك :</span>
            <span>
              <a :href="data.bank" target="_blank">
                <i class="fal fa-eye"></i>
              </a>
            </span>
          </div>
        </li>
        <li>
          <div class="state-count">
            <span> عدد الحاويات :</span>
            <span> {{ data.containerCount }} </span>
          </div>
        </li>
        <li>
          <div class="state-count">
            <span> أرقام الحاويات :</span>
            <v-chip
              color="#eeeeee"
              class="ml-1"
              v-for="item in data.containerData"
              :key="item.id"
            >
              {{ item.number }}
            </v-chip>
          </div>
        </li>
        <li>
          <div class="state-count">
            <span> الميناء :</span>
            <span> {{ data.port.name }} </span>
          </div>
        </li>
        <li>
          <div class="state-count">
            <span> تاريخ المستند :</span>
            <span> {{ data.file_date }} </span>
          </div>
        </li>
        <li>
          <div class="state-count">
            <span> الحالة :</span>
            <span v-if="data.status == 'pending'"> منتظر </span>
            <span v-else> مأكد </span>
          </div>
        </li>
      </ul>
      <!-- --------------------- -->
      <div class="custom_card">
        <div class="card-header">
          <h4 class="card-title">إضافة شهادة</h4>
        </div>

        <!-- ==== Start Form ==== -->
        <form @submit.prevent="validateCreateForm">
          <div class="container">
            <div class="row justify-content-between">
              <div class="col-lg-3 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="number"
                    step="any"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.chert_number"
                  />
                  <label for="name_input" class="form-label">رقم الشهادة</label>
                </div>
              </div>
              <div class="col-lg-3 py-0">
                <div class="input_wrapper top_label file_input">
                  <span class="file_input_label"> ملف الشهادة </span>
                  <label
                    for="reseat_image"
                    class="form-label"
                    v-if="!selectedFile.file"
                  ></label>
                  <label for="reseat_image" class="form-label" v-else>
                    {{ selectedFile.name }}
                  </label>
                  <input
                    type="file"
                    class="form-control"
                    id="reseat_image"
                    @change="handelSelectedFile"
                  />
                </div>
              </div>
              <div class="col-lg-3 py-0">
                <div class="input_wrapper top_label file_input">
                  <span class="file_input_label"> ملف الإفراج </span>
                  <label
                    for="reseat_image_two"
                    class="form-label"
                    v-if="!selectedFileTwo.file"
                  ></label>
                  <label for="reseat_image" class="form-label" v-else>
                    {{ selectedFileTwo.name }}
                  </label>
                  <input
                    type="file"
                    class="form-control"
                    id="reseat_image_two"
                    @change="handelSelectedFileTwo"
                  />
                </div>
              </div>
              <div class="col-lg-3 py-0">
                <div class="input_wrapper top_label date_input">
                  <label class="form-label">تاريخ الشهادة</label>
                  <v-menu
                    v-model="dateMenu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{on, attrs}">
                      <v-text-field
                        v-model="data.chert_date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data.chert_date"
                      @input="dateMenu = false"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                </div>
              </div>
            </div>
          </div>

          <div class="buttons_wrapper">
            <button
              class="button_style_1"
              :class="{buttonIndex: btnIsLoading}"
              :disabled="btnIsLoading"
            >
              إضافة
              <span class="btn_loader" v-if="btnIsLoading"></span>
            </button>
          </div>
        </form>
        <!-- ==== End Form ==== -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Create",

  data() {
    return {
      // loader
      loading: true,

      load_users: false,
      // search
      searchData: {
        username: null,
      },
      searchOptions: {
        search_users: "",
      },
      users: null,

      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: "اضافة شهادة",
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // Date_menues
      dateMenu: false,
      debit_dateMenu: false,

      // search_users
      search_users: "",

      // START:: SELECTED FILE DATA
      selectedFile: {
        file: null,
        name: null,
        path: null,
      },
      selectedFileTwo: {
        file: null,
        name: null,
        path: null,
      },
      // ========== create_data
      data: {
        file_number: null,
        polis_number: null,
        amount: null,
        company: null,
        bank: null,
        containerCount: null,
        containerData: [],
        containers: null,
        port: null,
        file_date: null,
        status: null,
        chert_number: null,
        chert_date: new Date().toISOString().slice(0, 10),
      },

      // ========== Fixed_data
      banks: null,
      companies: null,
      ports: null,
    };
  },

  computed: {
    total() {
      const num = this.data.amount * this.data.transfare_amount;
      return parseFloat(num.toFixed()).toLocaleString();
    },
  },

  watch: {
    [`searchOptions.search_users`](newVal, oldVal) {
      if (!newVal || newVal.length < 3) {
        this.users = null;
      } else {
        if (!newVal & (oldVal == "")) {
          this.get_filterd_users(oldVal);
        } else if ((newVal == "") & (oldVal != "")) {
          this.get_filterd_users(newVal);
        } else {
          this.get_filterd_users(newVal);
        }
      }
    },
  },

  methods: {
    //Get Data
    getData() {
      this.$axios({
        method: "GET",
        url: "client/import/" + this.$route.params.id,
      }).then((res) => {
        if (res.data.data.document_number) {
          this.data.file_number = res.data.data.document_number;
        } else {
          this.data.file_number = "لا يوجد";
        }
        this.data.polis_number = res.data.data.bl_number;
        this.data.amount = res.data.data.total;
        this.data.company = res.data.data.company;
        this.data.port = res.data.data.port;
        this.data.bank = res.data.data.bank_image;
        this.data.file_date = res.data.data.arrival_bank_document_date;
        this.data.containerCount = res.data.data.containers;
        this.data.containerData = res.data.data.import_containers;
        this.data.status = res.data.data.status;
      });
    },
    // get_filterd_users
    get_filterd_users(keyword) {
      this.load_users = true;
      this.$axios({
        method: "GET",
        url: `client/customer/search?keyword=${keyword}`,
      })
        .then((res) => {
          this.users = res.data.data;
          this.load_users = false;
        })
        .catch((err) => {
          this.load_users = false;
        });
    },

    // Get Data
    getCompanies() {
      // START:: GET SAFES
      this.$axios({
        method: "GET",
        url: `client/company_import`,
      })
        .then((res) => {
          this.companies = res.data.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
      // END:: GET SAFES
    },

    getPort() {
      // START:: GET BANKS
      this.$axios({
        method: "GET",
        url: `client/port`,
      })
        .then((res) => {
          this.ports = res.data.data;
        })
        .catch((err) => {
          console.log(err.response.data);
        });
      // END:: GET BANKS
    },

    // START:: HANDLING SELECTED FILE METHOD
    handelSelectedFile(e) {
      this.selectedFile.file = e.target.files[0];
      this.selectedFile.name = e.target.files[0].name;
      this.selectedFile.path = URL.createObjectURL(e.target.files[0]);
    },
    handelSelectedFileTwo(e) {
      this.selectedFileTwo.file = e.target.files[0];
      this.selectedFileTwo.name = e.target.files[0].name;
      this.selectedFileTwo.path = URL.createObjectURL(e.target.files[0]);
    },
    // END:: HANDLING SELECTED FILE METHOD

    // Validate Data
    validateCreateForm() {
      if (!this.btnIsLoading) {
        this.btnIsLoading = true;
        if (!this.data.chert_number) {
          this.$iziToast.error({
            timeout: 2000,
            message: "يرجى ادخال رقم الشهادة",
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.selectedFile.file) {
          this.$iziToast.error({
            timeout: 2000,
            message: "يجب إدراج ملف الشهادة  ",
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.selectedFileTwo.file) {
          this.$iziToast.error({
            timeout: 2000,
            message: "يجب إدراج ملف الإفراج  ",
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else if (!this.data.chert_date) {
          this.$iziToast.error({
            timeout: 2000,
            message: this.$t("forms.validation.date"),
            position: "topRight",
          });
          this.btnIsLoading = false;
          return;
        } else {
          this.submitData();
          return;
        }
      }
    },
    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("cert_number", this.data.chert_number);
      submit_data.append("cert_image", this.selectedFile.file);
      submit_data.append("release_file", this.selectedFileTwo.file);
      submit_data.append("cert_date", this.data.chert_date);
      // START:: APPEND REQUEST DATA
      this.$axios({
        method: "POST",
        url: "client/import/confirm_import/" + this.$route.params.id,
        data: submit_data,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 5000,
            message: this.$t("addSuccess"),
            position: "topRight",
          });
          this.$router.push({path: "/importFiles/all"});
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "topRight",
          });
          this.btnIsLoading = false;
        });
    },
  },

  created() {
    this.getCompanies();
    this.getPort();
    this.getData();
    setTimeout(() => {
      this.loading = false;
    }, 1000);
    // permisions
    var userType = JSON.parse(this.$store.state.usertype) || null;
    if (
      !userType.includes("superadmin") &&
      !userType.includes("containerOperations")
    ) {
      this.$router.push("/");
    }
  },
};
</script>
